

















































import { OperationsFilterVue } from "fs-pb-vue2/vueModels/history/OperationsFilterVue";
import { Component, Prop } from "vue-property-decorator";
import i18n from "@/i18n";

@Component
export default class OperationsFilter extends OperationsFilterVue {

  @Prop() periodVal!: string;

  dateClick(): void {
    this.$emit('dateClick', true)
  }

  operationsFilterItems: Array<any> = [
    {
      title: i18n.t("common.allOperation"),
      value: 'all'
    },
    {
      title: i18n.t("common.expenses"),
      value: 'exp'
    },
    {
      title: i18n.t("common.receipts"),
      value: 'rec'
    },
  ];

  /** Получение списка контрактов только карточные и текущие счета */
  get contracts(): any {
    const contracts = this.contractsStore.contracts.Contracts;
    const result: Array<any> = [
      { title: i18n.t("main.historyFilters.all"), value: null }
    ];
    for (const key in contracts) {
      const contract = contracts[key];
      if (
        (contract.IsOpen && !contract.Data.Hidden) ||
        this.isHiddenItemsVissible
      ) {
        result.push({
          title: contract.Data.Alias,
          value: contract.Data.Id
        });
      }
    }
    return result;
  }

}
